import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";

class LineChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [{
        name: "Ips Found",
        data: props.ipArray // Sample data
      }],
      options: {
        chart: {
          height: 400,
          type: 'line',
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        colors: ['#6366F1'], // Purple line
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        grid: {
          borderColor: '#E5E7EB',
          strokeDashArray: 4,
          yaxis: { lines: { show: false } },
          xaxis: { lines: { show: true } }
        },
        tooltip: {
          theme: 'light',
          x: { format: 'dd MMM' }, // Changed to show only date and month
          y: { formatter: value => `${value.toLocaleString()}` }
        },
        xaxis: {
          categories: props.dates.map(date => date?.split('T')[0]),
          labels: { style: { colors: '#666', fontSize: '12px' } },
          axisBorder: { show: false },
          axisTicks: { show: false }
        },
        yaxis: { show: false },
        markers: {
          size: 4,
          colors: ['#6366F1'],
          strokeColors: '#fff',
          strokeWidth: 2,
          hover: { size: 6 }
        }
      },
    };
  }

  render() {
    return (
      <><div className="flex justify-between items-start mb-4">
        <div>
          <div className="subHeadingTotal">{this.state.series[0].data.slice(-1)[0].toLocaleString()} total IPs Found</div>
        </div>
        {/* <div className="relative">
          <select className="bg-white border rounded-md px-3 py-1 text-sm shadow-sm">
            <option>All</option>
            <option>Weekly</option>
            <option>Monthly</option>
          </select>
        </div> */}
      </div><ReactApexChart options={this.state.options} series={this.state.series} type="line" className="chart-class" height={300} /></>
    );
  }
}

export default LineChart;
